import { useState, useRef, useEffect } from 'react';

const CampaignCategoryDropdown = ({ categories, value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedCategory = categories.find(cat => cat._id === value);

    return (
        <div className="relative" ref={dropdownRef}>
            <button
                type="button"
                className="w-full text-left px-3 py-2 border-2 rounded outline-primaryColor/30 flex justify-between items-center"
                onClick={() => setIsOpen(!isOpen)}
            >
                <span className="truncate">
                    {selectedCategory?.categoryName || 'Select Category'}
                </span>
                <svg
                    className={`w-4 h-4 ml-2 transition-transform ${isOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {isOpen && (
                <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded shadow-lg max-h-60 overflow-y-auto">
                    {categories.map((cat) => (
                        <div
                            key={cat._id}
                            className={`px-3 py-2 hover:bg-gray-100 cursor-pointer ${value === cat._id ? 'bg-blue-100' : ''}`}
                            onClick={() => {
                                onChange(cat._id);
                                setIsOpen(false);
                            }}
                        >
                            <span className="truncate block" title={cat.categoryName}>
                                {cat.categoryName}
                            </span>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
export default CampaignCategoryDropdown;

